import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { driverGroupSchema } from '../schemas/driver-group.schema';

/**
 * Returns a paginated response for Driver Groups
 * @param params Paged Collection Params
 * @returns Paged Collection of Driver Groups
 */
export function getDriverGroups(this: unknown, params?: PagedCollectionParams) {
  const requestUrl = `${fleetEnvironment.resolve(this).driverGroupsUrl}?${
    params ? params.urlParams : ''
  }`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(driverGroupSchema)));
}
